export const handleSplitInput = <T>(
  input: string,
  currentValues: T[],
  onUpdate: (newValues: T[]) => void,
  itemBuilder: (name: string, index: number) => T
) => {
  const items = input
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item.length > 0)
    .map(itemBuilder);

  const newValues = [...currentValues, ...items];
  onUpdate(newValues);
};
